import React from 'react';
import {
    usePropertyFetching,
    usePropertyPresentation,
} from '../../../../../contextsProperty/ContextProperties';
import LoadingPlaceholder from '../../../../../../muiComponents/LoadingPlaceholder';
import Title from '../../../Title';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Button from '../../../../../../muiComponents/Button';
import Menu from '../../../../components/Menu';
import routes from '../../../../../../utils/commonVariables/routes';
import encodeBase64 from '../../../../../../utils/encodeBase64';
import Card from '../../../../../../muiComponents/Card';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { taxesColumns } from '../../../../../../utils/property/propertyUtils';
import { commonIcons } from '../../../../../../utils/commonVariables/commonIcons';
import PropertySupplementRow from './PropertySupplementRow';

const PropertySupplementsList = () => {
    const { isFetching } = usePropertyFetching();
    const { supplements } = usePropertyPresentation();
    const translate = useTranslate();

    const getRouteToSupplementPanel = (id?: string) =>
        `${routes.landingPrivate}${routes.supplements}${
            id ? `?id=${encodeBase64(id)}` : ''
        }`;

    const menuItems = [
        {
            text: 'create_new_supplement',
            icon: 'Add',
            onClick: () => {
                const route = getRouteToSupplementPanel('new');
                window.open(route, route);
            },
        },
        {
            text: 'manage_all_supplements',
            icon: commonIcons.TAX,
            onClick: () => {
                const route = getRouteToSupplementPanel();
                window.open(route, route);
            },
        },
    ];
    return (
        <section className='flex-column gap-10' id='supplements'>
            <div className='flex flex-between'>
                {isFetching ? (
                    <LoadingPlaceholder
                        variant='text'
                        height={24}
                        width='100%'
                    />
                ) : (
                    <div className='width100perc flex flex-between flex-align-baseline'>
                        <Title text='supplements' />
                        <Menu menuItems={menuItems} />
                    </div>
                )}
            </div>
            <Card className='padding-inline-20 overflow-x-auto'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {taxesColumns.map(column => (
                                <TableCell
                                    key={column.id}
                                    className='text-capitalize'
                                >
                                    {translate(column.label)}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!supplements.length ? (
                            <TableRow>
                                <TableCell colSpan={taxesColumns.length}>
                                    <div className='flex-center'>
                                        <Button
                                            startIcon='Add'
                                            variant='text'
                                            onClick={() => {
                                                const route =
                                                    getRouteToSupplementPanel(
                                                        'new'
                                                    );
                                                window.open(route, route);
                                            }}
                                        >
                                            {translate('create_new_tax')}
                                        </Button>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ) : (
                            supplements.map(supplement => (
                                <PropertySupplementRow
                                    key={supplement.id}
                                    supplement={supplement}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </Card>
        </section>
    );
};

export default PropertySupplementsList;
